import { AdminApi, AdminVoucherDetail, AdminVoucherStep } from 'api';
import useApiCall from 'hooks/use-api-call';
import { useCallback, useEffect, useMemo, useState } from 'react';

export const useVoucherDetails = (voucherId: string, refreshVoucherDetails: boolean) => {
  const [voucher, setVoucher] = useState<AdminVoucherDetail>();
  const [steps, setSteps] = useState<AdminVoucherStep[]>([]);

  const { withApi, makeAuthenticatedApi, loading } = useApiCall();
  const api: AdminApi = useMemo(() => makeAuthenticatedApi(AdminApi), [makeAuthenticatedApi]);

  const fetchVoucherDetails = useCallback(() => {
    withApi(async () => {
      const voucherDetails = await api.adminVouchersRetrieve({ id: voucherId });
      setVoucher(voucherDetails);
    });
  }, [voucherId, api]);

  const fetchSteps = useCallback(() => {
    withApi(async () => {
      const stepsResponse = await api.adminVouchersVoucherStepsList({ id: voucherId });
      setSteps(stepsResponse);
    });
  }, [voucherId, api]);

  useEffect(() => {
    fetchVoucherDetails();
    fetchSteps();
  }, [withApi, api, voucherId, refreshVoucherDetails]);

  const changeVoucherActivation = useCallback(() => {
    withApi(async () => {
      await api.adminVouchersActivationCreate({
        id: voucherId,
        adminVoucherRequest: { code: voucher!.code, name: voucher!.name, active: !voucher!.active },
      });
      voucher!.active = !voucher!.active;
      setVoucher(voucher);
    });
  }, [voucherId, voucher?.active, withApi, api]);

  return { voucher, steps, changeVoucherActivation, loading };
};
